




















































































































































































































































































































































































































































































































































































































































































































































































































import XLSX from 'xlsx';
import Loading from 'vue-loading-overlay';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import ListEvents from '../../core/components/ListEvents.vue';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import LabelWithValue from '../../core/components/LabelWithValue.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import DownloadingModal from '../../core/components/DownloadingModal.vue';
import ModalNewPolicy from '../../insurance/components/ModalNewPolicy.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import IgnoredPeriods from '../../insurance/components/IgnoredPeriods.vue';
import ModalRanchSimulator from '../../insurance/components/ModalRanchSimulator.vue';
import RanchSatelliteImages from '../components/ranch/RanchSatelliteImages.vue';
import RanchVariablesChart from '../components/ranch/RanchVariablesChart.vue';
import RanchEditableFieldInfo from '../../insurance/components/ranch/RanchEditableFieldInfo.vue';
import RanchEditEstimatedDate from '../../insurance/components/ranch/RanchEditEstimatedDate.vue';
import ModalLinkRanchs from '../../insurance/components/ModalLinkRanchs.vue';
import PreloadIgnoredPeriods from '../components/PreloadIgnoredPeriods.vue';
import DownloadWorkSegments from '../components/DownloadWorkSegments.vue';
import CalcStatus from '../../insurance/components/CalcStatus.vue';
import SegmentsTable from '../../insurance/components/SegmentsTable.vue';
import RanchLinkButton from '../../insurance/components/RanchLinkButton.vue';
import { KeyNames } from '../../insurance/keys-names';
import Button from '../../core/components/Button.vue';
import CustomSwitch from '../../core/components/CustomSwitch.vue';
import Input from '../../core/components/Input.vue';
import LoadingIndicator from '../../core/components/LoadingIndicator.vue';
import ListWithItems from '../../core/components/ListWithItems.vue';
import MapReferences from '../../core/components/MapReferences.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { AuthStoreHelper, CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import {
    splitStringByIndex,
    EventBus,
    TypeEventBus,
    sortObjectByPropertyName,
    formatDate,
    goToUrl,
    getUniqueId,
    getRandomColor,
    getAlertColorByPriority,
    insuranceColors,
    segmentsColors,
    getCurrentTimestamp,
    isDict,
    getImageAsBlob,
    getIndexFromList,
    PRIVILEGE_KEYS,
    isNumber,
    getValueWithCustomDecimals,
    ID,
    ColorsList,
    isNullOrEmpty,
} from '../../core/utils/';
import { booleanFormatter, formatCommaSeparatedStringList, formattedDate, nullFormatterGetZero } from '../../core/utils/table-formatters';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import {
    getCompanyItemById,
    getDateFromTimestamp,
    matchedIndexIdInArray,
    removeItemsFromList,
    parseFloatNumber
} from '../../core/utils';
import { Chart } from 'highcharts-vue';
import Highcharts, { error } from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import { getHarvestRanchInfoTooltipPerformanceHumidity } from '../indicators';
exportingInit(Highcharts);

import { InsuranceServices } from '../api/InsuranceServices';
import moment from 'moment';
import Axios from 'axios';
import { getRandom } from 'features/core/components/Map';
import { generateZipFile } from '../../norms';
import {
    getUrlVehicleConfiguration,
    getUrlFarmingDetail,
    getParsedBounds,
    getCalculationStatusTooltip,
    getCalculationStatusColor,
    alertHarvesRecalculation,
    getUrlRanchSowingDetail,
    overlappedRanchMsg,
    getOverlapAlertText,
    getRanchStateDescription
} from '../utils';
import axios from 'axios';
import { dateTypes } from '../../core/models';
import { exportHarvestRanchDepurationCsv } from '../api/models';
import { farmingTypeOptions } from '../helpers';
import { editableField, editableHarvestField, HarvestRanchEditableFields, HarvestRanchEditableFieldType, HarvestRanchFieldTypes, insuranceCarrierEditableFields, ManualHarvestRanchValue, RanchFieldPriority, ranchFieldsProperties, SatelitalHarvestRanchValue } from '../ranch';
import { HarvestRanchAditionalFields } from '../harvestIndicators';
import { defaultNoDataValue, getUnitTypeForValue, getValueAndUnit, getValueByType, getValueUnit, unitForValues, unitsValuesChoices } from '../../core/api';

@Component({
    components: {
        highcharts: Chart,
        AlertBox,
        Summary,
        Combobox,
        SimpleTable,
        ModalInsuranceHarvest,
        Button,
        CustomSwitch,
        LabelWithValue,
        Input,
        LoadingIndicator,
        DeleteConfirmation,
        Loading,
        SimpleMap,
        IgnoredPeriods,
        ListEvents,
        ListWithItems,
        ModalCheckboxList,
        DownloadingModal,
        MapReferences,
        ModalRanchSimulator,
        RanchSatelliteImages,
        RanchVariablesChart,
        RanchEditableFieldInfo,
        ModalLinkRanchs,
        SegmentsTable,
        CalcStatus,
        PreloadIgnoredPeriods,
        DownloadWorkSegments,
        RanchLinkButton,
        InfoIcon,
        PlusEyeButtons,
        ModalNewPolicy,
        RanchEditEstimatedDate
    }
})
export default class InsuranceHarvestDetail extends Mixins(
    AuthStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    pageTitle: string = 'Detalle de Chacra de Cosecha';
    chartCurrentTimestamp: string = '';
    chartSatelliteOptions: object = {};
    currentSatellitalImageIndex: number = 0;
    bandSelected: string = '';
    //base data
    ranchName: any = '';
    ranchState: any = '';
    securedArea: any = '';
    company: string = '';
    companyID: string = '';
    farmingName: string = '';
    errorMsg: string = '';
    farmingId: number = -1;
    startDate: string = defaultNoDataValue;
    harvestStartDate: string = '';
    endDate: string = defaultNoDataValue;
    polygonArea: string = '';
    polygonThresh: string = '';
    performance: string = defaultNoDataValue;
    tooltipHumidity: string = '';
    tooltipPerformance: string = '';
    humidity: string = defaultNoDataValue;
    daysOfThresh: string = '0';
    estimatedHarvestDate: string = '-';
    isCalculatingPerformance: boolean = false;
    estimatedHarvestLabel: string = KeyNames.estimated_harvest_date;
    policiesList: Array<object> = [];
    basePolygons: Array<object> = [];
    defaultPolygons: Array<object> = [];
    pendingDetail: boolean = true;
    hasChanges: boolean = false;
    hasChangesMsg: string = alertHarvesRecalculation;
    loadingMap: boolean = true;
    showLayers: boolean = true;
    showReferences: boolean = true;
    loadingPatchRanch: boolean = false;
    loadingSimulatorSettings: boolean = false;
    pendingEvents: boolean = false;
    pendingSegment: boolean = false;
    visibleModalPolicy: boolean = false;
    generatingSatelliteImages: boolean = false;
    gettingSatelliteImages: boolean = false;
    forcingCalculate: boolean = false;
    recalculatingHarvest: boolean = false;
    visibleModalExportDepuration: boolean = false;
    visibleModalSimulator: boolean = false;
    visibleSatelliteImages: boolean = false;
    visibleModalEditableField: boolean = false;
    visibleModalEstimatedDate: boolean = false;
    visibleDownloadingModal: boolean = false;
    pendingExportDepuration: boolean = false;
    visibleModalLinkRanchs: boolean = false;
    editingPolicy: boolean = false;
    selectedRanchToLink: object | null = null;
    mostRepresentativeImage: string = '';
    defaultFileNameExportDepuration: string = '';
    defaultProgressRanchPolygon: string = '';
    listReferences: any = [];
    calculationStatus: null | object = null;
    editableFieldInfo: editableField = {
        telematic: null,
        manual: null,
        satelital: null,
        priority: 0,
        value: 0
    };
    editableFieldType: string = '';
    editableFieldLabel: string = '';
    parseValues: Function = getValueByType;
    currentRanchData: object = {};
    LabelFields: object = KeyNames;
    overlappedRanchMessage: string = overlappedRanchMsg;
    overlappedRanch: null | string = null;
    colorEstimatedDate: string = ColorsList.orange;
    optionsFinished: Array<object> = [
        {
            id: 1,
            value: 'Si',
            kei: true
        },
        {
            id: 2,
            value: 'No',
            kei: false
        }
    ];
    seedOptions: Array<object> = [];
    editableIndicators: HarvestRanchEditableFields = HarvestRanchAditionalFields
    notesList: Array<object> = [];
    scalePerformance: Array<number> = [];
    geojsonSegmentsOfWork: any = null;
    geojsonCalibrationPasses: any = null;
    performancePrediction: object = {
        prediction_date: null,
        prediction_state: -1
    };
    geojsonTravel: any = null;
    vehiclesOptions: Array<object> = [];
    scaleHumidity: Array<number> = [];
    thereIsHarvestPolygon: boolean = false;
    ranchHasCsv: boolean = false;
    ranchIsCalculating: boolean = false;
    showMap: boolean = false;
    exportDepurationTitle: string = '';
    ranchHarvestDate: string = '';
    ranchSowingDate: string = '';
    alarmColor: string = ColorsList.orange;
    //tables
    itemsSegments: Array<object> = [];
    noExistSatelliteImagesText: string = 'No hay imágenes satelitales';
    generateSatelliteImagesText: string = 'Generar imágenes satelitales';
    linkRanchsText: string = 'Vínculo con Chacra de Siembra';
    sowingRanchLink: object | null = null;
    ranchId: string | null = null;
    ranchCsvURL: string = '';
    ignoredPeriodsList: Array<object> = [];
    satelliteImages: Array<object> = [];
    harvestedPolygons: any = null;
    exportDepurationOptions: object = {
        see_ranch_progress: {
            title: 'Polígono de Avance',
            key: 'see_ranch_progress',
            checked: false,
            disabled: false,
            loading: false,
            disabledTooltip: 'Esta chacra no tiene polígono de avance',
            icon: null,
        },
        see_polygon_ranch: {
            title: 'Polígono de la Chacra',
            key: 'see_polygon_ranch',
            checked: false,
            loading: false,
            disabled: true,
            disabledTooltip: 'Esta chacra no tiene un poligono',
            icon: null
        },
        see_telemetry_points: {
            title: 'Puntos de telemetría',
            key: 'see_telemetry_points',
            checked: false,
            disabled: false,
            loading: false,
            icon: null
        },
        see_ranch_csv: {
            title: 'CSV de la chacra',
            key: 'see_ranch_csv',
            checked: false,
            disabled: false,
            disabledTooltip: 'Esta chacra no tiene CSV',
            loading: false,
            icon: null
        },
        see_performance_telemetry: {
            title: 'Rinde Telemetría (img)',
            key: 'see_performance_telemetry',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde Telemetría',
            loading: false,
            icon: null
        },
        see_performance_csv: {
            title: 'Rinde CSV (img)',
            key: 'see_performance_csv',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde CSV',
            loading: false,
            icon: null
        },
        see_humidity_telemetry: {
            title: 'Humedad Telemetría (img)',
            key: 'see_humidity_telemetry',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Humedad Telemetría',
            loading: false,
            icon: null
        },
        see_humidity_csv: {
            title: 'Humedad CSV (img)',
            key: 'see_humidity_csv',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Humedad CSV',
            loading: false,
            icon: null
        },
        see_most_representative: {
            title: 'Imagen Representativa',
            key: 'see_most_representative',
            checked: false,
            disabled: false,
            disabledTooltip: 'No fue seleccionada ninguna imagen como representativa',
            icon: null
        },
        deliverable_complete: {
            title: 'Mapa de Rendimiento',
            key: 'deliverable_complete',
            disabled: false,
            icon: null,
        },
        telemetry_and_csv : {
            title: 'CSV + Telemetría',
            key: 'telemetry_and_csv',
            disabled: false,
            icon: null,
        }
    };


    updateSummaryFields(){
        let self = this;
        let summaryData = [
           {
             text: 'Nombre:',
             value: self.ranchName,
             info: ''
           },
           {
             text: 'Área Polígono:',
             value: getValueAndUnit(self.polygonArea, unitsValuesChoices.area),
             info: ''
           }
        ];


        if(self.cropTypeSelected !== null){
            summaryData.push({
                text: `${KeyNames.crop_type}:`,
                value: self.cropTypeSelected['value'],
                info: ''
            })
        }
        if(self.editableIndicators.sowing_start.value !== null){
            summaryData.push({
                text: `${KeyNames.sowing_start}:`,
                value: getValueByType(self.editableIndicators.sowing_start.value),
                info: ''
            })
        }
        if(self.startDate !== defaultNoDataValue){
            summaryData.push({
                text: `${KeyNames.start_date}:`,
                value: getValueByType(self.startDate),
                info: ''
            })
        }
        if(self.endDate !== defaultNoDataValue){
            summaryData.push({
                text: `${KeyNames.end_date}:`,
                value: getValueByType(self.endDate),
                info: ''
            })
        }

        if(this.hideIndicatorsForCarrierLimited){
            if(isNumber(self.performance)){
                summaryData.push({
                    text: `${KeyNames.performance}:`,
                    value: getValueAndUnit(self.performance, unitsValuesChoices.performance),
                    info: ''
                })
            }
            if(isNumber(self.humidity)){
                summaryData.push({
                    text: `${KeyNames.humidity}:`,
                    value: getValueAndUnit(self.humidity, unitsValuesChoices.humidity),
                    info: ''
                })
            }
        }
        
        this.summaryData = summaryData;
    }

    get getRanchFinished(){
       return this.ranchFinished
    }

    get getPredictionState(){
        return this.performancePrediction['prediction_state']
    }

    get getPredictionStateIcon(){

        switch(this.getPredictionState){
            case 0:
                return 'mdi-file-send';
            case 1:
                return 'mdi-checkbox-marked-circle';
            case -1:
                return 'mdi-cloud-off-outline'

        }
    }

    get getPredictionStateColor(){
        switch(this.getPredictionState){
            case 0:
                return 'primary';
            case 1:
                return 'success';
            case -1:
                return 'gray'

        }
    }
    
    get getAnniCalcStatus(){
        let tooltip = '';
        tooltip = `<b>Estado de Predicción: </b> ${this.$_getInsuranceProperties['prediction_states'][this.performancePrediction['prediction_state']]}<br>`

        if(this.performancePrediction['prediction_date']){
            tooltip += `<b>Última actualización: </b>  ${formatDate(this.performancePrediction['prediction_date'])}<br>`
        }
        return tooltip

    }


    get ranchHasHarvestDate(){
        return !isNullOrEmpty(this.ranchHarvestDate)
    }



    get shouldSeePredictPerformanceButton(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_PREDICTION];
    }

    get shouldPredictPerformance(){
        if(!this.ranchHasHarvestDate || !this.ranchHasSowingDate){
            return false
        }

        return true
    }

    get predictPerformanceTooltip(){
        if(!this.ranchHasHarvestDate){
            return 'La chacra no tiene Fecha de Cosecha'
        }

        if(!this.ranchHasSowingDate){
            return 'La chacra no tiene Fecha de Siembra'
        }

        if(this.isCalculatingPerformance){
            return `El cálculo se esta ejecutando. El resultado se enviará por mail `
        }
    }

    get ranchHasSowingDate(){
        if(this.editableIndicators && this.editableIndicators['sowing_start']){
            if(isNullOrEmpty(this.editableIndicators['sowing_start']['value'])){
                return false
            }
        }
        return true
    }

    get ranchHasSatellitalImages(){
        return this.visualizationPriority['satellite_images']
    }
    get ranchHasSatellitalValues(){
        return this.visualizationPriority['satellite_values']
    }

    get ranchHasMapData(){
        return this.visualizationPriority['map']
    }

    get modalLoadingDialog(): HTMLFormElement {
        return this.$refs.downloadingModal as HTMLFormElement;
    }
    get modalSegmentsTable(): HTMLFormElement {
        return this.$refs.segmentsTable as HTMLFormElement;
    }
    get ignoredPeriodsHarvestRanchEl(): HTMLFormElement {
        return this.$refs.harvestRanchIgnoredPeriods as HTMLFormElement;
    }

    calculateEstimatedHarvestDate(){
        InsuranceServices.calculateHarvestEstimatedDate(
            this.ranchId as ID
        ).then((res) => {
            this.$_successAddRecipients(res.message);
            
            this.performancePrediction = res.performance_prediction;
        }).catch((err)=> {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo enviar a calcular la Fecha Estimada de Cosecha'
            });
        }).finally(() => {
            
        })
    }

    visibilityModalLinkRanchs(value) {
        this.visibleModalLinkRanchs = value;
    }
    visibilityModalEditableField(value) {
        this.visibleModalEditableField = value;
    }
    visibilityModalEditEstimatedDate(value) {
        this.visibleModalEstimatedDate = value;
    }

    disableExportRanchCsv() {
        this.updateExportDepurationItem('see_ranch_csv', 'disabled', true);
    }

    disableExportProgressRanch() {
        this.updateExportDepurationItem('see_ranch_progress', 'disabled', true);
    }

    enableExportPolygonRanch(){
        this.updateExportDepurationItem('see_polygon_ranch', 'disabled', false);
    }

    layersItems: object = {
        see_performance_map: {
            title: 'Rinde Telemetría',
            key: 'see_performance_map',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde Telemetría',
            icon: 'mdi-barley'
        },
        see_performance_csv: {
            title: 'Rinde CSV',
            key: 'see_performance_csv',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde CSV',
            icon: 'mdi-barley'
        },
        see_most_representative: {
            title: 'Imagen Representativa',
            key: 'see_most_representative',
            checked: false,
            disabled: false,
            disabledTooltip: 'No fue seleccionada ninguna imagen como representativa',
            icon: 'mdi-satellite-variant'
        },
        see_humidity_map: {
            title: 'Humedad Telemetría',
            key: 'see_humidity_map',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Humedad Telemetría',
            icon: 'mdi-water-percent'
        },
        see_humidity_csv: {
            title: 'Humedad CSV',
            key: 'see_humidity_csv',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Humedad CSV',
            icon: 'mdi-water'
        },
        see_ranch: {
            title: 'Chacra',
            key: 'see_ranch',
            checked: true,
            disabled: false,
            icon: 'mdi-square-outline'
        },
        see_avance: {
            title: 'Lineas de Trabajo (geocerca de avance)',
            key: 'see_avance',
            disabled: false,
            checked: false,
            icon: 'mdi-format-line-style',
            disabledTooltip: 'No hay polígono de avance'
        },
        see_calibration_passes: {
            title: 'Calibraciones',
            key: 'see_calibration_passes',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay pasadas de calibración',
            icon: 'mdi-wrench'
        },
        machine_travel: {
            title: 'Recorrido máquinas',
            key: 'machine_travel',
            checked: false,
            disabled: !this.existMapLayers ? false : true,
            disabledTooltip: '',
            icon: 'mdi-tractor'
        },
        see_segments_of_work: {
            title: 'Clasificacion por segmentos de trabajo',
            key: 'see_segments_of_work',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay líneas de segmentos',
            icon: 'mdi-segment'
        }
    };
    mapLayers: object = {};
    cropTypes: Array<object> = [];

    //selectors
    policySelected: any = null;
    policyRV: boolean = false;
    stateSelected: any = null;
    stateRV: boolean = false;
    cropTypeSelected: any = null;
    grainTypeSelected: any = null;
    grainRV: boolean = false;
    cropTypeRv: boolean = false;
    ranchFinished: boolean = false;
    seedSelected: any = null;
    ranchLowFlow: boolean = false;
    lowFlowInRanchSimulator: any = null;
    finishedRV: boolean = false;
    lowFlowRV: boolean = false;
    seedRv: boolean = false;
    vehicleFilterSelected: any = null;
    filterVehicleRV: boolean = false;
    loadingMessageModal: string = '';
    ranchProgressPercent: number = -1;
    filteredSegmentsOfWork: Array<object> = [];
    chartOptions: object = {};
    visibleModalViewSegments: boolean = false;
    cancelTokenLoadSegment: any = null;
    segmentInfo: object | null = null;
    vehicleID: number = -1;
    clickedSegmentCompanyID: number = -1;
    responseData: object = {};
    ranchHarvest: object = {};
    referencesCalibrations: any = null;
    calibrationsReferences: any = null;
    vehiclesReferences: any = null;
    workLinesReferences: any = null;
    manualArea: string = '';
    enableRestoreButton: boolean = false;
    listOfPointsPerSegment: Array<object> = [];
    ranchBounds: object | null = null;
    performanceMapImage: string = '';
    performanceMapImageCSV: string = '';
    humidityMapImage: string = '';
    humidityMapCSVImage: string = '';
    ranchSimulatorConfig: object = {};
    selectedSegmentsOfWork: Array<object> = [];
    closingConditionSelected: object = {};
    closingConditionsOptions: Array<object> = [];
    closingConditionRV: boolean = false;
    visualizationPriority: object = {
        map: false,
        satellite_images: false,
        satellite_values: false
    }
    summaryData: Array<object> = []
    collapsiblePanel: number | null = null;
    polygonsChanged: number = 0;
    boolFormat: Function = booleanFormatter;
    insuranceCarrierVisibleFields: string[] = insuranceCarrierEditableFields;
    policyToPatch: object | null = null;

    updateHarvestedEstimatedDate(value:string){
        this.estimatedHarvestDate = value;
    }

    createNewPolicy(){
        if(this.getHarvestId == -1){
            this.$_showEmptyLastReport('La chacra no tiene una Zafra asociada');
            return
        }
        this.policyToPatch = null;
        this.visibilityPolicyModal(true);
    }

    clickModifyPolicy(){
        this.policyToPatch = this.policySelected;
        this.visibilityPolicyModal(true);
    }

    addNewPolicyToPoliciesList(newPolicy: object){
        this.policiesList.push(newPolicy);
        if(this.policySelected == null){
            this.updatePolicySelected(newPolicy);
        }
    }

    updatePolicyInPoliciesList(newPolicy: object){
        let policyId = newPolicy['id'];
        let policyIndex = this.policiesList.findIndex(policy => policy['id'] == policyId);

        if(policyIndex > -1){
            this.$set(this.policiesList[policyIndex], 'number', newPolicy['number'])
            this.$set(this.policiesList[policyIndex], 'secured_area', newPolicy['secured_area'])
            this.$set(this.policiesList[policyIndex], 'id', newPolicy['id']);
            this.updatePolicySelected(this.policiesList[policyIndex]);
        }
    }

    visibilityPolicyModal(value){
        this.visibleModalPolicy = value;
    }

    getUnitTypeForField(index){
        return getUnitTypeForValue(index)
    }

    changeCollapsible(){
        // console.log("changeCollapsible");
    }

    fieldIsVisible(field){
        if(!this.isCarrier){
            return true;
        }
        if(this.insuranceCarrierVisibleFields.includes(field)){
            return true;
        }
        return false;
    }

 


    updateClosingConditionSelected(value){
        this.closingConditionSelected = value;
    }
    updateClosingConditionSelectedRv(value){
        this.closingConditionRV = value;
    }


    addMissingFieldsToGeojson(geoJsonsegmentsOfWork){
        //esta funcion le agrega al archivo Geojson que tiene los segmentos de trabajo
        //campos que estan en la tabla pero faltan en el archivo y necesitan exportarse
        let self = this;
        if(geoJsonsegmentsOfWork !== null){
            //recorro la lista de segmentos
            let segmentsOfWork = this.itemsSegments;
            for (let index = 0; index < segmentsOfWork.length; index++) {
                const currentSegment = segmentsOfWork[index];
                //busco el segmento de la tabla en el geojson fijandome si coincide con fecha de inicio y fin
                let indexSegmentInGeojsonFeatures = geoJsonsegmentsOfWork['features'].findIndex(
                    feature => feature['properties']['start'] === currentSegment['start'] &&
                    feature['properties']['end'] === currentSegment['end']
                );
                if(indexSegmentInGeojsonFeatures !== -1){
                    //encontre el segmento en el geojson
                     //agrego los campos faltantes a la feature actual del geojson
                     geoJsonsegmentsOfWork['features'][indexSegmentInGeojsonFeatures]['properties'] = {
                        ...geoJsonsegmentsOfWork['features'][indexSegmentInGeojsonFeatures]['properties'],
                        performance: nullFormatterGetZero(currentSegment['performance']),
                        humidity: nullFormatterGetZero(currentSegment['humidity']),
                        uncalibrated_performance: nullFormatterGetZero(currentSegment['uncalibrated_performance']),
                        uncalibrated_humidity: nullFormatterGetZero(currentSegment['uncalibrated_humidity']),
                     }
                }
            }
        }
        return geoJsonsegmentsOfWork
    }

    editRanchField(ranchField: editableField, type:HarvestRanchEditableFieldType, label: string){
        this.editableFieldInfo = ranchField;
        this.editableFieldType = type;
        this.editableFieldLabel = label;
        this.visibilityModalEditableField(true);
    }

    editHarvestDate(){
        this.visibilityModalEditEstimatedDate(true);
    }

    updateEditableFieldInfo(field:string, newData: editableField){
        this.editableIndicators[field] = newData;
        this.editableFieldInfo = newData;
    }

    @Watch('$_getInsuranceProperties')
    getRanchUrl(sowingRanchId){
        return getUrlRanchSowingDetail(sowingRanchId)
    }

    removeLinkToRanch(){
        this.sowingRanchLink = null;
    }

    addNewLinkToRanch(newRanchLink, harvestRanchId){
        this.sowingRanchLink = newRanchLink;
    }

    @Watch('$_getInsuranceProperties', {deep: true, immediate: true})
    observableProperties() {
        this.assignPropertiesData();
        if(this.ranchId){
             this.getRanchDetail(this.ranchId);
        }
    }

    linkRanchs(){
        this.selectedRanchToLink = {
            id:this.ranchId,
            name: this.ranchName
        }
        this.visibilityModalLinkRanchs(true);
    }

    updateSelectedSegmentsInMap(elements) {
        this.selectedSegmentsOfWork = elements;
        this.mapHarvestDetail.selectSegmentsOfWork(elements);
    }

    updateExportDepurationItem(kei, prop, value) {
        this.exportDepurationOptions[kei][prop] = value;
    }

    updateRanchName(newName) {
        this.ranchName = newName;
    }
    updateHasChanges(value) {
        this.hasChanges = value;
    }
    updateCalculationStatus(value) {
        this.calculationStatus = value;
    }
    updateRanchSimulatorConfig(value) {
        this.ranchSimulatorConfig = value;
    }
    assignMostRepresentativeImage(value) {
        this.mostRepresentativeImage = value;
        if (value == null) {
            this.disableMostRepresentativeLayer();
        }
    }
    updateRanchProgressPercent(newName) {
        this.ranchProgressPercent = newName;
    }
    updateRanchState(newName) {
        this.ranchState = newName;
    }
    updateRanchBounds(value: object | null) {
        this.ranchBounds = value;
    }
    updateRanchCSVURL(value: string) {
        this.ranchCsvURL = value;
    }
    disableMostRepresentativeLayer() {
        this.updateLayerOption('see_most_representative', 'checked', false);
        this.updateLayerOption('see_most_representative', 'disabled', true);
        this.updateExportDepurationItem('see_most_representative', 'disabled', true);
        this.updateExportDepurationItem('see_most_representative', 'checked', false);
    }
    updatePerformanceMapImage(url: string) {
        if (url == null) {
            this.updateLayerOption('see_performance_map', 'disabled', true);
            this.updateExportDepurationItem('see_performance_telemetry', 'disabled', true);
            this.performanceMapImage = url;
        } else {
            this.performanceMapImage = url;
        }
    }
    updateGeojsonCalibrationPasses(segments) {
        let self = this;
        let calibrationsReferences: Array<object> = [];
        if (segments !== null) {
            let features = segments['features'];
            features = features.map(function(item, index) {
                let customId = getUniqueId();
                let currentColor = insuranceColors[index] ? insuranceColors[index] : getRandomColor();
                let startDate = moment(item['properties']['start'], 'YYYY-MM-DD HH:mm:ss').format(
                    'YYYY-MM-DDTHH:mm:ss'
                );
                let endDate = moment(item['properties']['end'], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss');
                item['properties']['name'] = '';
                item['properties']['strokeColor'] = currentColor;
                item['properties']['customId'] = customId;
                item['properties']['visible'] = false;
                item['properties']['veh_description'] = self.getVehicleData(item['properties']['vehicle']);
                item['properties']['veh_path'] = self.getSegmentUrl(item['properties']['vehicle'], startDate, endDate);
                calibrationsReferences.push({
                    color: currentColor,
                    vehicle: self.getVehicleData(item['properties']['vehicle'])
                });
                return item;
            });
            // this.mapHarvestDetail.addGeoJson(segments);
        } else {
            this.updateLayerOption('see_calibration_passes', 'disabled', true);
        }
        this.referencesCalibrations = calibrationsReferences;
        this.geojsonCalibrationPasses = segments;
    }

    modifyRanchFromHarvest(feature: google.maps.Data.Feature){
        this.modifyPolygonFromMap(feature);
        this.mapHarvestDetail.modifyPolygon(feature);
    }

    modifyRanchFromSatellital(feature: google.maps.Data.Feature){
        this.modifyPolygonFromMap(feature);
        EventBus.$emit(TypeEventBus.MODIFY_RANCH_IN_SATELLITAL, feature);
    }

    modifyPolygonFromMap(feature: google.maps.Data.Feature){
        // console.log("modifyPolygonFromMap harvest");
        feature.setProperty('harvest_type', this.cropTypeSelected !== null ? this.cropTypeSelected['value'] : '')
        feature.setProperty('name', this.ranchName);
        let customId = feature.getProperty('customId');
        feature.setProperty('name', this.ranchName);
    }

    saveRanchPolygon(ranchName: string, cropTypeSelected: object | null, coords, type){
        this.ranchName = ranchName;
        let cropTypeValue = cropTypeSelected !== null ? cropTypeSelected['value'] : null;
        this.setRanchCropType(cropTypeValue);

        this.modifyRanch(coords, type);
    }

    modifyRanch(coords, type) {
        let self = this;
        let hasCoords = coords.length > 0;
        if(hasCoords){
            this.pendingMap(true);
        }
        let seedWasSelected = this.seedSelected !== null ? this.seedSelected['id'] : null;
        let data = {
            name: this.ranchName,
            policy: Number(this.policySelected['id']),
            secured_area: this.securedArea !== null ? Number(this.securedArea) : null,
            harvest_type: this.cropTypeSelected == null ? null : Number(this.cropTypeSelected['id']),
            low_flow: this.ranchLowFlow,
            finished: this.ranchFinished,
            ...(hasCoords ? { [type]: coords } : {}),
            seed_group: seedWasSelected !== null ? Number(this.seedSelected['id']) : null,
            closing_condition: Number(this.closingConditionSelected['id'])
        };
        this.toggleRanch(false);
        this.loadingModifyRanch(true);
        InsuranceServices.patchRanch(Number(self.ranchId), data)
            .then(res => {
                let updatedRanch = res['data']['updated_ranch'];
                self.$_successDeleteRecipients('Chacra editada correctamente');
                self.setRanchState(updatedRanch['state']);
                self.updateCoordsInRanchPolygon(updatedRanch);
                self.loadingModifyRanch(false);
                self.updateSummaryFields();
                self.updatePolicyInPoliciesList(updatedRanch['policy'])
            })
            .catch(error => {
                self.loadingModifyRanch(false);
                self.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo editar la chacra'
                });
                // self.showErrorPathRanch(error)
            }).finally(() => {
                this.pendingMap(false);
            });
    }

    updateCurrentSatellitalImageIndex(value: number) {
        this.currentSatellitalImageIndex = value;
    }

    showRecalculatingInfo() {}

    preloadIgnoredPeriod(){
        this.ignoredPeriodsHarvestRanchEl.preselectIgnoredPeriods(this.selectedSegmentsOfWork);
    }

    getSegmentUrl(vehicleId: number, datetime_from: string, datetime_to: string) {
        let env_domain = process.env.VUE_APP_DOMAIN;
        let companyId = this.companyID;
        let url =
            env_domain +
            'travel/?c_id=' +
            companyId +
            '&v_id=' +
            vehicleId +
            '&date_start=' +
            datetime_from +
            '&date_end=' +
            datetime_to +
            '';
        return url;
    }

    updateGeojsonSegmentsOfWork(segments) {
        let self = this;
        if (segments !== null && isDict(segments)) {
            let features = segments['features'];
            features = features.map(function(item, index) {
                let customId = getUniqueId();
                let currentColor = segmentsColors[index] ? segmentsColors[index] : getRandomColor();
                item['properties']['name'] = '';
                item['properties']['strokeColor'] = currentColor;
                item['properties']['customId'] = customId;
                item['properties']['visible'] = false;
                item['properties']['veh_description'] = self.getVehicleData(item['properties']['vehicle']);
                item['properties']['veh_path'] = self.getSegmentUrl(
                    item['properties']['vehicle'],
                    item['properties']['start'],
                    item['properties']['end']
                );
                let indexInSegmentsTable = self.itemsSegments.findIndex(
                    segment =>
                        segment['start'] === item['properties']['start'] && segment['end'] === item['properties']['end']
                );
                if (indexInSegmentsTable !== -1) {
                    self.itemsSegments[indexInSegmentsTable]['customId'] = customId;
                    self.itemsSegments[indexInSegmentsTable]['color'] = currentColor;
                }
                return item;
            });
            // this.mapHarvestDetail.addGeoJson(segments);
        } else {
            this.updateLayerOption('see_segments_of_work', 'disabled', true);
        }
        let updatedGeojson = self.addMissingFieldsToGeojson(segments);
        this.geojsonTravel = updatedGeojson;
        this.geojsonSegmentsOfWork = updatedGeojson;
        
    }
    updatePerformanceMapImageCSV(url: string) {
        if (url == null) {
            this.updateLayerOption('see_performance_csv', 'disabled', true);
            this.updateExportDepurationItem('see_performance_csv', 'disabled', true);
        }
        this.performanceMapImageCSV = url;
    }
    updateHumidityMapImage(url: string) {
        if (url == null) {
            this.updateLayerOption('see_humidity_map', 'disabled', true);
            this.updateExportDepurationItem('see_humidity_telemetry', 'disabled', true);
        }
        this.humidityMapImage = url;
    }
    updateHumidityMapCSVImage(url: string) {
        if (url == null) {
            this.updateLayerOption('see_humidity_csv', 'disabled', true);
            this.updateExportDepurationItem('see_humidity_csv', 'disabled', true);
        }
        this.humidityMapCSVImage = url;
    }
    updateSecuredArea(value) {
        if (value === '') {
            value = null;
        }
        this.securedArea = value;
    }
    updateManualArea(value) {
        this.manualArea = value;
    }
    updateRanchHasCsv(value) {
        if (!value) {
            this.disableExportRanchCsv();
        }
        this.ranchHasCsv = value;
    }
    visibilityModalExportDepuration(value) {
        this.visibleModalExportDepuration = value;
    }
    visibilityRestoreButton(value) {
        this.enableRestoreButton = value;
    }
    visibilityDownloadingModal(value) {
        this.visibleDownloadingModal = value;
    }
    visibilityModalSimulator(value) {
        this.visibleModalSimulator = value;
    }
    updateCompany(newName) {
        this.company = newName;
    }
    updateCompanyId(newName) {
        this.companyID = newName;
    }
    updateFarmingName(newName) {
        this.farmingName = newName;
    }
    updateFarmingId(id) {
        this.farmingId = id;
    }
    updateDaysWorked(value) {
        this.daysOfThresh = value;
    }
    updatePolygonArea(value) {
        this.polygonArea = value;
    }
    updateHarvestStartDate(value) {
        this.harvestStartDate = value;
    }
    updateStartDate(value) {
        this.startDate = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateHumidity(value) {
        this.humidity = value;
    }
    updatePerformance(value) {
        this.performance = value;
    }
    updateRealPolygonThresh(value) {
        this.polygonThresh = value;
    }
    updatePendingDetail(value) {
        this.pendingDetail = value;
    }
    pendingMap(value) {
        this.loadingMap = value;
    }
    loadingComments(value) {
        this.pendingEvents = value;
    }
    //selectors
    updatePolicySelected(newName) {
        this.policySelected = newName;
    }
    updateVehicleFilterSelected(value) {
        this.vehicleFilterSelected = value;
    }
    updateVehicleFilterRV(newName) {
        this.filterVehicleRV = newName;
    }
    updatePolicyRV(newName) {
        this.policyRV = newName;
    }
    updateCropTypeSelected(newName) {
        this.cropTypeSelected = newName;
    }
    updateSeedSelected(newName) {
        this.seedSelected = newName;
    }
    updateSeedRv(newName) {
        this.seedRv = newName;
    }
    updateCropTypeSelectedRV(newName) {
        this.cropTypeRv = newName;
    }
    updateFinishedRV(newName) {
        this.finishedRV = newName;
    }
    updateLowFlowRV(newName) {
        this.lowFlowRV = newName;
    }
    updateStateSelected(newName) {
        this.stateSelected = newName;
    }
    updateStateRV(newName) {
        this.stateRV = newName;
    }
    updateGrainType(newName) {
        this.grainTypeSelected = newName;
    }
    updateGrainTypeRV(newName) {
        this.grainRV = newName;
    }
    setPoliciesList(list) {
        this.policiesList = list;
    }
    setMapLayers(value) {
        this.mapLayers = value;
    }
    setRanchNotes(value) {
        this.notesList = [];
        this.notesList = value;
    }
    loadPreviousSimulationConfig(originalConfig) {
        this.visibilityModalSimulator(false);
        this.ranchSimulatorConfig = {};
        setTimeout(() => {
            this.ranchSimulatorConfig = JSON.parse(originalConfig);
            this.visibilityModalSimulator(true);
        }, 0);
    }
    setWorkSegments(list) {
        let self = this;
        list.forEach(segment => {
            let vehicleSegment = segment['vehicle'];
            let vehicleIndex = self.vehiclesOptions.findIndex(item => item['id'] == vehicleSegment);
            if (vehicleIndex !== -1) {
                self.vehiclesOptions[vehicleIndex]['has_segment'] = true;
                segment['vehicle'] = self.vehiclesOptions[vehicleIndex];
            }
            segment['customId'] = getUniqueId();
        });
        this.itemsSegments = list;
    }
    toggleShowLayers(value) {
        this.showLayers = !this.showLayers;
    }
    showSettingsSimulator() {
        this.loadingSimulatorSettings = true;
        InsuranceServices.getRanchConfigSimulator(Number(this.ranchId))
            .then(res => {
                this.updateRanchSimulatorConfig(res);
                this.loadingSimulatorSettings = false;
                this.visibilityModalSimulator(true);
            })
            .catch(error => {
                this.loadingSimulatorSettings = false;
                if (error && error.response && error.response.data && error.response.data.message) {
                    this.$_showHistoricalError(error.response.data.message);
                } else {
                    this.$_showHistoricalError('No se pudo obtener la configuración de la chacra');
                }
            });
    }
    showSatelliteImages() {
        this.gettingSatelliteImages = true;
        InsuranceServices.getSatellitalImagesList(
            this.ranchId
        ).then((res) => {
            let images = res;
            if(images.length == 0){
                this.$_showHistoricalError('No hay imágenes satelitales')
            }else{
                this.satelliteImages = images;
                this.visibleSatelliteImages = true;
            }
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron obtener las imagenes satelitales'
            });
        }).finally(() => {
            this.gettingSatelliteImages = false;
        })


        
    }
    toggleReferences(value) {
        this.showReferences = !this.showReferences;
    }
    loadingModifyRanch(value) {
        this.loadingPatchRanch = value;
    }

    updateVehicleReferences(vehiclesList) {
        this.vehiclesReferences = null;
        this.vehiclesReferences = vehiclesList;
    }

    updateCalibrationsReferences(calibrationsReferences) {
        this.calibrationsReferences = null;
        this.calibrationsReferences = calibrationsReferences;
    }

    updateWorkLinesReferences(workLines) {
        this.workLinesReferences = null;
        this.workLinesReferences = workLines;
    }

    viewVehicleDetail(item) {
        if(!this.isCarrier){
            let url = getUrlVehicleConfiguration(item['vehicle']['id'], this.farmingId, farmingTypeOptions.harvest);
            goToUrl(url, true);
        }
        
    }

    get widthSatelliteImages(){
        let defValue = 'col-12 pt-0 pb-0 pr-0 ';

        if(this.ranchHasMapData || this.ranchHasSatellitalValues){
            defValue += ' col-lg-6'
        }
        if(!this.ranchHasMapData && this.ranchHasSatellitalValues){
            defValue += ' col-xl-5'
        }
        return defValue

    }
    get widthVariablesContainer(){
        let defValue = 'col-12 pl-0 pr-0 ';

        if(!this.ranchHasMapData && this.ranchHasSatellitalValues){
            defValue += 'col-lg-6 col-xl-7'
        }
        return defValue

    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    get isCarrierLimited(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER_LIMITED];
    }

    get hideIndicatorsForCarrierLimited(): boolean {
        return this.isCarrierLimited && !this.getRanchFinished;
    }

    



    mounted() {
        let self = this;
        if (this.hasParams) {
            let urlParams = new URLSearchParams(window.location.search);
            this.ranchId = urlParams.get('id') !== null ? urlParams.get('id') : null;
        }
        this.assignPropertiesData();
        EventBus.$on(TypeEventBus.MODIFY_RANCH_FROM_MAP, this.modifyPolygonFromMap);
        setTimeout(() => {
            if (self.ranchId) {
                self.getRanchNotes();
            }
        }, 0);
    }

    assignPropertiesData() {
        this.cropTypes = this.$_getInsuranceProperties['harvest_type'];
        this.closingConditionsOptions = this.$_getInsuranceProperties['closing_conditions_options'];
        this.seedOptions = this.$_getInsuranceProperties['seed_groups'];
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    parseNumber(value) {
        return parseFloatNumber(value);
    }

    addNewComment(newComment, base64ImagesList: string[]) {
        let data = {
            ranch: this.ranchId,
            text: newComment,
            public: this.isCarrier
        };
        this.loadingComments(true);
        
        InsuranceServices.postRanchNote(data)
            .then(res => {
                let newNote = res['ranch_note'];
                if(base64ImagesList.length > 0){
                     this.addImagesToExistingNote(newNote['id'], base64ImagesList);
                }else{
                    this.getRanchNotes();
                }
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    async addImagesToExistingNote(noteId: string, base64ImagesList: string[]){
        for (let index = 0; index < base64ImagesList.length; index++) {
            const imagebase64 = base64ImagesList[index];
            let imageConfig = new FormData();
            const imageAsBlob = await getImageAsBlob(imagebase64);
            imageConfig.append('image', imageAsBlob)
            imageConfig.append('public', "false")
            imageConfig.append('ranch_note', noteId)
            imageConfig.append('force_public', "false")
            await this.addImageToNote(imageConfig);
        }
        this.getRanchNotes();
        this.$_showAddPointOfInterest('Imagenes agregadas con éxito');
    }


    removeImageFromNotes(imageIdToRemove: number, imageIndex){
        InsuranceServices.deleteRanchNoteImage(
            imageIdToRemove
        ).then(res => {
            this.$_showAddPointOfInterest(res.data.message);
        }).catch(err => {
            
        })
    }


    async addImageToNote(config: FormData){
        let response = await InsuranceServices.addImageToRanchNote(
            config
        ).then(res => {
            // console.log("imagen agregada a la nota", res);
        }).catch(err => {
           
        })
        return response
    }

    

    removeComment(idToRemove) {
        this.loadingComments(true);
        InsuranceServices.deleteRanchNote(idToRemove)
            .then(res => {
                let indexNoteToRemove = matchedIndexIdInArray(this.notesList, idToRemove);
                if (indexNoteToRemove !== -1) {
                    this.notesList.splice(indexNoteToRemove, 1);
                }
                this.setRanchNotes(this.notesList);
                this.loadingComments(false);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    generateSatelliteImages(){
        this.generatingSatelliteImages = true;
        if(this.ranchId !== null){
            InsuranceServices.generateSatelliteImages(Number(this.ranchId))
                .then(res => {
                    this.$_successLoadingDialog({
                        response: res,
                        alternative_msg: 'Se enviaron a generar las imágenes satelitales'
                    });
                    this.generatingSatelliteImages = false;
                })
                .catch(err => {
                    this.generatingSatelliteImages = false;
                    this.$_catchLoadingDialog({
                        response: err.response.data || {},
                        alternative_msg: 'No se pudo enviar a generar las imágenes'
                    });
                });
        }
        
    }

    modifyComment(commentToModify: object, base64ImagesList: string[]) {
        this.loadingComments(true);
        let commentPublic =
            commentToModify && commentToModify['public'] !== undefined ? commentToModify['public'] : false;
        commentToModify['public'] = commentPublic;
        InsuranceServices.patchRanchNote(commentToModify)
            .then(res => {
                if(base64ImagesList.length > 0){
                     this.addImagesToExistingNote(res['data']['ranch_note']['id'], base64ImagesList);
                }else{
                    this.getRanchNotes();
                }
                this.$_showAddPointOfInterest(res['data']['message']);
            })
            .catch(err => {
                this.getRanchNotes();
                this.loadingComments(false);
            });
    }

    getRanchNotes() {
        this.loadingComments(true);

        InsuranceServices.getRanchNotes(Number(this.ranchId))
            .then(res => {
                this.setRanchNotes(res['ranch_notes']);
                this.loadingComments(false);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    replaceMostRepresentativeImage(imageObject) {
        /* Accion de marcar imagen satelital como representativa */

        //oculto si hay una imagen anterior
        this.toggleMostRepresentativeImage(false);

        //en la lista de imagenes satellitales actualizo la key "most_representative"
        this.updateMostRepresentativeKeyInImagesList(imageObject);

        //actualizo la imagen representativa almacenada
        this.assignMostRepresentativeImage(imageObject);

        //muestro la capa representativa
        this.toggleMostRepresentativeImage(true);

        //marco como checked la capa de imagen representativa
        this.updateLayerOption('see_most_representative', 'checked', true);
    }

    updateMostRepresentativeKeyInImagesList(imageObject) {
        this.satelliteImages = this.satelliteImages.map(function(item) {
            return {
                ...item,
                is_most_representative: imageObject['png_url'] === item['png_url'] ? true : false
            };
        });
    }

    checkVisualizationPriority(){
        if(this.visualizationPriority['satellite_images']){
            this.showSatelliteImages();
        }

        if(this.visualizationPriority['map']){
            this.showMap = true;
            this.mapHarvestDetail.closeContextMenu();
        }
    }


    getRanchDetail(ranchId) {
        let self = this;
        InsuranceServices.getRanchDetail(ranchId)
            .then(res => {
                self.updateRanchBounds(res['bounds']);
                self.getMapLayers(self.ranchId);
                this.loadManualValue(res['ranch']['editable_fields']);
                this.responseData = res;
                this.updatePendingDetail(false);
                this.updateHasChanges(res['has_changes']);
                this.assignMostRepresentativeImage(res['most_representative_image']);
                this.sowingRanchLink = res['sowing_ranch_link'];
                this.visualizationPriority = res['view'];
                this.checkVisualizationPriority();

                setTimeout(() => {
                    self.setBaseData(res);
                    self.setPolygons(res);
                }, 1000);
            })
            .catch(err => {
               this.showCatchLoadingModal(err, 'Fallo detalle de chacra')
                this.updatePendingDetail(false);
            });
    }

    setRanchState(state: number) {
        //Recibe el estado de la chacra y el porcentaje de avance, retorna la string
        //que corresponde al estado
        this.updateRanchState(getRanchStateDescription(state, this.$_getInsuranceProperties['ranch_states']));
    }

    getChartOptions(series) {
        return {
            tooltip: {
                formatter: function() {
                    let variable = this.series.name;
                    let value = this.key;
                    let keyUnit = this.series.userOptions.unit
                    return `
                        <b>Variable: ${variable}</b><br>
                        <b>Valor:</b> 
                        ${getValueAndUnit(value, unitsValuesChoices[keyUnit])} 
                    `
                }
            },
            time: {
                useUTC: false
            },
            yAxis: [
                {
                    title: {
                        text: 'Rendimiento'
                    }
                },
                {
                    title: {
                        text: 'Humedad'
                    },
                    opposite: true
                }
            ],
            chart: {
                type: 'column',
                zoomType: 'x'
            },
            title: {
                text: ''
            },
            series: series,
             exporting: {
                buttons: {
                    contextButton: {
                        menuItems: [
                            'downloadPNG',
                            'downloadJPEG',
                            'downloadPDF',
                        ]
                    }
                }
            }
        };
    }

    selectPolylineInWorkSegments(feature: google.maps.Data.Feature) {
        //select a polyline clicked from map to work segments table
        let startDate = feature.getProperty('start');
        let endDate = feature.getProperty('end');
        //find polyline in work segments and select it;
        let indexPolylineInWorkSegments = this.itemsSegments.findIndex(
            segment => segment['start'] === startDate && segment['end'] === endDate
        );
        if (indexPolylineInWorkSegments !== -1) {
            this.modalSegmentsTable.addSegmentToSelectedOnes(this.itemsSegments[indexPolylineInWorkSegments]);
        }
    }

    selectedWorkSegment(clickedSegment) {
        this.layersItems['see_segments_of_work']['checked'] = true;
        this.toggleSegmentsOfWork(true);
    }

    enablePerformanceMapTelemetry(url) {
        if (url !== null) {
            this.togglePerformanceMap(false);
            this.updateLayerOption('see_performance_map', 'checked', true);
            this.togglePerformanceMap(true);
        }
    }

    removeAllSatelliteImages(){
        this.satelliteImages = [];
    }

    getMapLayers(ranchId) {
        this.pendingMap(true);
        // let res = this.responseLayers;
        InsuranceServices.getRanchLayers(ranchId)
            .then(res => {
                this.setMapLayers(res['data']);
                this.scalePerformance = res['data']['performance_scale'];
                this.scaleHumidity = res['data']['humidity_scale'];
                this.updateGeojsonCalibrationPasses(res['data']['calibrations']);
                this.updateGeojsonSegmentsOfWork(res['data']['segments']);
                this.updatePerformanceMapImage(res['data']['images']['performance_telemetry_transparent']);
                this.updatePerformanceMapImageCSV(res['data']['images']['performance_csv_transparent']);
                this.updateHumidityMapImage(res['data']['images']['humidity_telemetry_transparent']);
                this.updateHumidityMapCSVImage(res['data']['images']['humidity_csv_transparent']);
                this.updateRanchCSVURL(res['data']['ranch_csv']);
                this.pendingMap(false);
                this.setCharts(res);
                this.enablePerformanceMapTelemetry(res['data']['images']['performance_telemetry_transparent']);
            })
            .catch(err => {
                this.$_showHistoricalError('No se pudieron traer los datos de las capas');
                this.setMapLayers({});
                this.pendingMap(false);
                this.chartOptions = {};
            });
    }

    setCharts(res) {
        let series = [
            {
                type: 'line',
                name: 'Rendimiento',
                data: res['data']['performance_dist'] !== null ? res['data']['performance_dist'] : [],
                yAxis: 0,
                unit: unitsValuesChoices.performance
            },
            {
                type: 'line',
                name: 'Humedad',
                data: res['data']['humidity_dist'] !== null ? res['data']['humidity_dist'] : [],
                yAxis: 1,
                unit: unitsValuesChoices.humidity
            }
        ];

        this.chartOptions = this.getChartOptions(series);
    }

    getFeatureWithCustomId(features) {
        features[0]['properties']['name'] = this.ranchName;
        features[0]['properties']['customId'] = getUniqueId();
        features[0]['properties']['visible'] = true;
        features[0]['properties']['strokeColor'] = 'black';
        features[0]['properties']['harvest_type'] = this.cropTypeSelected !== null ? this.cropTypeSelected['value'] : '';
        return features;
    }

    setPolygons(res) {
        let self = this;
        let data: any = [];
        let hasAvance = false;
         this.harvestedPolygons = null;
        if (res['ranch'] && res['ranch']['polygon']) {
            this.enableExportPolygonRanch();
            data = [...self.getFeatureWithCustomId(res['ranch']['polygon']['features'])];
        }

        if (
            res['harvested_polygon'] &&
            res['harvested_polygon']['polygon'] &&
            res['harvested_polygon']['polygon']['features']
        ) {
            hasAvance = true;
            
            this.defaultProgressRanchPolygon = res['harvested_polygon']['polygon']['features'][0]['properties']['name'];
            let harvestedPolygonsFeatures = self.getFeatureWithCustomId(res['harvested_polygon']['polygon']['features']);
            this.harvestedPolygons = {
                type: 'FeatureCollection',
                features: harvestedPolygonsFeatures
            }
        }

        this.basePolygons = data;
        // this.defaultPolygons = JSON.parse(JSON.stringify(data));

        if(this.basePolygons.length == 0){
            this.updateLayerOption('see_ranch', 'checked', false);
        }

        let geoJson = {
            type: 'FeatureCollection',
            features: this.basePolygons
        };
        if(this.mapHarvestDetail){
            this.mapHarvestDetail.addGeoJson(geoJson);
        }
    }

    setCloseCondition(closeCondition: number | null){
        if(closeCondition !== null){
            let indexCloseCondition = getIndexFromList(this.closingConditionsOptions, 'id', closeCondition);
            if(indexCloseCondition !== -1){
                this.updateClosingConditionSelected(this.closingConditionsOptions[indexCloseCondition])
            }
        }
    }

    changeEditableIndicators(fields: HarvestRanchEditableFields){
        this.editableIndicators = fields;
    }

    loadManualValue(fields: HarvestRanchEditableFields){
        if(fields){
            this.changeEditableIndicators(fields);
            //asigno valor de area manual
            if(fields.harvested_area.priority == ManualHarvestRanchValue){
                this.updateManualArea(fields.harvested_area.manual);
            }
        }
    }

    setBaseData(res) {
        let self = this;
        this.setPoliciesList(res['policies']);
        this.updateFarmingName(res['farming']['name']);
        this.updateFarmingId(res['farming']['id']);
        if (res['ranch']['start_date']) {
            this.updateStartDate(res['ranch']['start_date']);
        }
        if (res['ranch']['end_date']) {
            this.updateEndDate(res['ranch']['end_date']);
        }
        this.ranchHarvestDate = res['ranch']['harvest_date'];
        this.performancePrediction = res['ranch']['performance_prediction'];
        this.estimatedHarvestDate = res['ranch']['estimated_harvest_date'];
        this.setCloseCondition(res['ranch']['closing_condition']);
        this.updateCompany(res['farming']['company']['name']);
        this.updateRanchName(res['ranch']['name']);
        this.updateRanchProgressPercent(res['ranch']['progress_percent']);
        this.updateRanchFinished(res['ranch']['finished']);
        this.updateRanchLowFlow(res['ranch']['low_flow']);
        this.setRanchState(res['ranch']['state']);
        this.setRanchCropType(res['ranch']['harvest_type']);
        this.setRanchSeedGroup(res['ranch']['seed_group']);
        this.updatePolygonArea(res['ranch']['area']);
        this.updateHarvestStartDate(res['harvest']['start_date']);
        if (res['harvested_polygon']) {
            this.updateDaysWorked(res['harvested_polygon']['days_worked']);
            this.updateLayerOption('see_avance', 'disabled', false);
        } else {
            this.disableExportProgressRanch();
            this.updateLayerOption('see_avance', 'disabled', true);
        }
        if (res['harvest']) {
            this.setRanchHarvest(res['harvest']);
            this.updateCalculationStatus(res['harvest']['calculation_status']);
        }
        if (res['ranch_data']) {
            this.updateHumidity(parseFloatNumber(res['ranch_data']['humidity']));
            this.updatePerformance(parseFloatNumber(res['ranch_data']['performance']));
            this.updateRanchHasCsv(res['ranch_data']['has_csv']);
            this.tooltipHumidity = getHarvestRanchInfoTooltipPerformanceHumidity(res['ranch_data']['humidity_detailed_info']);
            this.tooltipPerformance = getHarvestRanchInfoTooltipPerformanceHumidity(res['ranch_data']['performance_detailed_info']);
        }
        this.updateSecuredArea(res['ranch']['secured_area']);
        this.updatePolicySelected(res['policy']);
        this.setVehicles(res['vehicles']);
        this.setWorkSegments(res['segments']);
        if (res['error_lapses']) {
            this.setErrorLapses(res['error_lapses']);
        }
        this.updateSummaryFields();
        this.updateCompanyId(res['farming']['company']['id']);
        this.overlappedRanch = getOverlapAlertText(formatCommaSeparatedStringList(res['ranch']['overlap'])) 
    }

    setRanchHarvest(harvest) {
        this.ranchHarvest = harvest;
    }

    setErrorLapses(error_lapses) {
        let self = this;
        let errorLapses = error_lapses.map(function(period) {
            let vehicleId = period['vehicle'];
            let vehicleData: any = {
                id: vehicleId
            };
            if (vehicleId) {
                let indexVehicleInVehicleList = matchedIndexIdInArray(self.vehiclesOptions, vehicleId);
                if (indexVehicleInVehicleList > -1) {
                    vehicleData = self.vehiclesOptions[indexVehicleInVehicleList];
                }
            }
            return {
                ...period,
                vehicle: vehicleData
            };
        });
        this.setIgnoredPeriods(errorLapses);
    }

    setIgnoredPeriods(value) {
        this.ignoredPeriodsList = [];
        this.ignoredPeriodsList = value;
    }

    setVehicles(vehicles) {
        let self = this;
        this.vehiclesOptions = vehicles.map(function(item, index) {
            return {
                id: item['id'],
                vin: item['vin'],
                description: item['description'],
                vehicleData: item['description'],
                color: self.getReferenceColorByIndex(index),
                has_segment: false
            };
        });
    }

    clickBtnExportDepuration() {
        this.exportDepurationTitle = 'Exportar depuración';
        if (this.ranchName !== '') {
            this.exportDepurationTitle += ' Chacra: <b>' + this.getUpdatedRanchName() + '</b>';
            this.defaultFileNameExportDepuration =
                'depuración_chacra_' + this.getUpdatedRanchName() + '_' + getCurrentTimestamp(dateTypes.globalFilterDateFormat);
        }
        this.visibilityModalExportDepuration(true);
    }

    updateMessageInLoadingModal(msg) {
       this.$_showLoadingDialog(msg)
    }

    showLoadingModal(msg) {
        this.$_showLoadingDialog(msg)
    }

    showSuccessLoadingModal(msg) {
        this.$_successLoadingDialog({
            response: {},
            alternative_msg: msg
        });
    }
    showCatchLoadingModal(err, alternativeMsg) {
        this.$_catchLoadingDialog({
            response: err,
            alternative_msg: alternativeMsg
        });
    }

    getUpdatedRanchName() {
        let name = this.ranchName;
        if (name.indexOf('.') !== -1) {
            name = name.replace(/\./g, '_');
        }
        return name;
    }

    async exportDepurationAction(folderName: string, optionsToExport: Array<string>) {
        this.pendingExportDepuration = true;
        let dataToExport: any = {};

        for (let i = 0; i < optionsToExport.length; i++) {
            let option = optionsToExport[i];
            this.showLoadingModal('Generando archivo...');
            let updatedRanchName = this.getUpdatedRanchName();

            switch (option) {
                case 'see_ranch_progress':
                    //Adjunto el archivo para el polígono de avance
                    this.harvestedPolygons['features'][0]['properties']['name'] = this.defaultProgressRanchPolygon;
                    let fileName = 'poligono_avance_chacra_' + updatedRanchName + '.geojson';
                    let ranchProgressData = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.harvestedPolygons['features'][0])]
                    });
                    dataToExport[fileName] = ranchProgressData;
                    break;

                case 'see_polygon_ranch':
                    //Adjunto el archivo para el polígono de la chacra
                    let nameRanchFile = 'poligono_chacra_' + updatedRanchName + '.geojson';
                    this.basePolygons[0]['properties']['name'] = updatedRanchName;
                    let ranchData = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.basePolygons[0])]
                    });
                    dataToExport[nameRanchFile] = ranchData;
                    break;

                case 'see_telemetry_points':
                    //Adjunto el archivo de los puntos de telemetría
                    this.showLoadingModal(
                        'Descargando puntos de telemetría...<br> <small>(Ésta acción puede tomar unos minutos)</small>'
                    );
                    let nameCsvPoints = 'puntos_telemetria_chacra_' + updatedRanchName + '.csv';
                    let telemetryData = await InsuranceServices.getRanchTelemetryCSV(Number(this.ranchId))
                        .then(res => res)
                        .catch(error => {
                            this.showCatchLoadingModal(error, 'No se pudieron obtener los puntos de telemetría');
                            return false;
                        });
                    if (telemetryData) {
                        dataToExport[nameCsvPoints] = telemetryData;
                    }
                    break;

                case 'see_ranch_csv':
                    //Adjunto el archivo del csv de la chacra
                    this.showLoadingModal(
                        'Descargando CSV de la chacra...<br> <small>(Ésta acción puede tomar unos minutos)</small>'
                    );
                    let nameCsvRanch = 'csv_chacra_' + updatedRanchName + '.csv';
                    let csvRanchData = await InsuranceServices.getRanchCSV(
                        Number(this.ranchId)
                        // this.ranchCsvURL
                    )
                        .then(res => res)
                        .catch(error => {
                            this.showCatchLoadingModal(error, 'No se pudo obtener el CSV de la chacra');
                            return false;
                        });
                    if (csvRanchData) {
                        dataToExport[nameCsvRanch] = csvRanchData;
                    }
                    break;
                case 'see_performance_telemetry':
                    this.showLoadingModal('Descargando imagen de Rinde Telemetría');
                    //Adjunto la imagen de Rinde Telemetría
                    let imgPerformanceTelemetry = await this.downloadImageFromUrl(this.performanceMapImage);
                    let fileNameRT = 'rinde_telemetria_chacra_' + updatedRanchName + '.png';
                    if (imgPerformanceTelemetry !== null) {
                        dataToExport[fileNameRT] = new Blob([imgPerformanceTelemetry], { type: 'image/png' });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen de Rinde Telemetría');
                    }
                    break;
                case 'see_performance_csv':
                    this.showLoadingModal('Descargando imagen de Rinde CSV');
                    //Adjunto la imagen de Rinde CSV
                    let imgPerformanceCSV = await this.downloadImageFromUrl(this.performanceMapImageCSV);
                    let fileNameRCSV = 'rinde_csv_chacra_' + updatedRanchName + '.png';
                    if (imgPerformanceCSV !== null) {
                        dataToExport[fileNameRCSV] = new Blob([imgPerformanceCSV], { type: 'image/png' });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen de Rinde CSV');
                    }
                    break;
                case 'see_humidity_telemetry':
                    this.showLoadingModal('Descargando imagen de Humedad Telemetria');
                    //Adjunto la imagen de Humedad Telemetria
                    let imgHumTel = await this.downloadImageFromUrl(this.humidityMapImage);
                    let fileNameHum = 'humedad_telemetria_chacra_' + updatedRanchName + '.png';
                    if (imgHumTel !== null) {
                        dataToExport[fileNameHum] = new Blob([imgHumTel], { type: 'image/png' });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen de Humedad Telemetría');
                    }
                    break;
                case 'see_humidity_csv':
                    this.showLoadingModal('Descargando imagen de Humedad CSV');
                    //Adjunto la imagen de Humedad CSV
                    let imgHumCsv = await this.downloadImageFromUrl(this.humidityMapCSVImage);
                    let fileNameHumCSV = 'humedad_csv_chacra_' + updatedRanchName + '.png';
                    if (imgHumCsv !== null) {
                        dataToExport[fileNameHumCSV] = new Blob([imgHumCsv], { type: 'image/png' });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen de Humedad CSV');
                    }
                    break;
                case 'see_most_representative':
                    this.showLoadingModal('Descargando imagen Representativa (PNG)');
                    //Adjunto la imagen Representativa (PNG)
                    // console.log('Adjunto la imagen Representativa'); //aca
                    let imgRepresentativePNG = await this.downloadImageFromUrl(this.mostRepresentativeImage['png_url']);
                    let fileNameBase = 'imagen_representativa_chacra_' + updatedRanchName;
                    let fileNameRepresentative = fileNameBase + '.png';
                    if (imgHumCsv !== null) {
                        dataToExport[fileNameRepresentative] = new Blob([imgRepresentativePNG], { type: 'image/png' });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen Representativa (PNG)');
                    }
                    //Adjunto la imagen Representativa (TIFF)
                    this.showLoadingModal('Descargando imagen Representativa (Tiff)');
                    let imgRepresentativeTif = await this.downloadImageFromUrl(this.mostRepresentativeImage['tif_url']);
                    let fileNameRepresentativeTiff = fileNameBase + '.tiff';
                    if (imgRepresentativeTif !== null) {
                        dataToExport[fileNameRepresentativeTiff] = new Blob([imgRepresentativeTif], {
                            type: 'image/tiff'
                        });
                    } else {
                        this.$_showHistoricalError('No se pudo obtener la imagen Representativa (TIFF)');
                    }
                    break;
                case 'deliverable_complete':
                    //aca
                    this.showLoadingModal(`Descargando ${this.exportDepurationOptions['deliverable_complete']['title']}`);
                    let linkDeliverableCompleteUrl = await this.getHarvestCsvUrl(true, false);
                   
                    if(linkDeliverableCompleteUrl !== null){
                        let fileNameHumCSV = 'entregable_csv_y_telemetria_chacra_' + updatedRanchName + '.csv';
                        let csvData = await this.downloadArrayBuffer(linkDeliverableCompleteUrl);
                        if (imgHumCsv !== null) {
                            dataToExport[fileNameHumCSV] = csvData ;
                        } else {
                            this.$_showHistoricalError(`No se pudo adjuntar ${this.exportDepurationOptions['deliverable_complete']['title']}`);
                        }
                        break;
                    }else{
                        this.$_showHistoricalError(`No hay datos de Entregable ${this.exportDepurationOptions['deliverable_complete']['title']}`);
                        break;
                    }
                case 'telemetry_and_csv':
                    this.showLoadingModal('Descargando CSV + Telemetría');
                    let linkCsvAndTelemetryUrl = await this.getHarvestCsvUrl(false, true);
                    if(linkCsvAndTelemetryUrl !== null){
                        let csvData = await this.downloadArrayBuffer(linkCsvAndTelemetryUrl);
                        let fileNameHumCSV = 'csv_y_telemetria_chacra_' + updatedRanchName + '.csv';
                        if (imgHumCsv !== null) {
                            dataToExport[fileNameHumCSV] = csvData ;
                        } else {
                            this.$_showHistoricalError('No se pudo adjuntar CSV + Telemetría');
                        }
                        break;
                    }else{
                        this.$_showHistoricalError('No hay datos de CSV + Telemetría');
                        break;
                    }
            }
        }
        this.showLoadingModal('Descargando archivo...');

        this.pendingExportDepuration = false;
        generateZipFile(folderName, dataToExport, false);
        this.showSuccessLoadingModal('Depuración descargada con éxito');
    }

    async getHarvestCsvUrl(deliverable_complete: boolean, telemetry_and_csv: boolean){
        let data:exportHarvestRanchDepurationCsv = {
            ranch_id: Number(this.ranchId),
            deliverable_complete: deliverable_complete,
            telemetry_and_csv: telemetry_and_csv,
        }
        try {
            let fileLink = await InsuranceServices.exportHarvestRanchCsv(data);
            return fileLink['data']
        } catch (error) {
            return null;
        }
    }

    removeExtraKeysFromPolygon(polygonObject: object) {
        //removes the keys 'customId' && 'visible'
        return {
            ...polygonObject,
            properties: {
                name: polygonObject['properties']['name']
            }
        };
    }

    async downloadArrayBuffer(url) {
        try {
            let response = await InsuranceServices.getArrayBufferFromUrl(url);
            return response
        } catch (error) {
            return null;
        }
    }
    async downloadImageFromUrl(url) {
        try {
            let base64 = await InsuranceServices.downloadImageFromUrl(url);
            return base64;
        } catch (error) {
            return null;
        }
    }

    updateRanchFinished(value) {
       this.ranchFinished = value;
    }

    updateRanchLowFlow(value) {
        this.ranchLowFlow = value
    }

    setRanchCropType(harvestType: string | null) {
        let cropType = harvestType == null ? '' : harvestType;
        if(this.cropTypes){
            let indexInCropTypes = this.cropTypes.findIndex(item => item['value'] === cropType);
            if (indexInCropTypes !== -1) {
                this.updateCropTypeSelected(this.cropTypes[indexInCropTypes]);
            } else {
                this.updateCropTypeSelected(null);
            }
        }
    }
    setRanchSeedGroup(seedGroup: number | null) {
        this.updateSeedSelected(null);
        if (seedGroup !== null && this.seedOptions) {
            let indexInSeedList = this.seedOptions.findIndex(item => Number(item['id']) === seedGroup);
            if (indexInSeedList !== -1) {
                this.updateSeedSelected(this.seedOptions[indexInSeedList]);
            }
        }
    }

    backToAnlyticView() {
        this.$router.push(NAME_ROUTES.INSURANCE_FARMING_ANALYTIC.path);
    }

    get getHarvestId() {
        return this.ranchHarvest && this.ranchHarvest['id'] ? this.ranchHarvest['id'] : -1;
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    get existSegmentsOfWork() {
        return this.itemsSegments.length !== 0 ? true : false;
    }

    get getActiveScale() {
        if (this.layersItems['see_performance_map']['checked'] || this.layersItems['see_performance_csv']['checked']) return this.scalePerformance;
        if (this.layersItems['see_humidity_map']['checked'] || this.layersItems['see_humidity_csv']['checked']) return this.scaleHumidity
        return []
    }

    get mostRepresentativeIsActive(){
        return this.layersItems['see_most_representative']['checked']
    }

    get getActiveScaleType() {
        if (this.layersItems['see_performance_map']['checked'] || this.layersItems['see_performance_csv']['checked'])  return 'Rendimiento';
        if (this.layersItems['see_humidity_map']['checked'] || this.layersItems['see_humidity_csv']['checked'])  return 'Humedad';
        return ''
    }

    get mapHarvestDetail(): HTMLFormElement {
        return this.$refs.mapHarvestDetail as HTMLFormElement;
    }

    get existCSV() {
        return this.ranchHasCsv ? true : false;
    }
    get existMapLayers() {
        return this.mapLayers == null ? false : true;
    }

    viewFarming() {
        if (this.farmingId !== -1) {
            let url = getUrlFarmingDetail(this.farmingId);
            goToUrl(url, true);
        }
    }

    itemChanged(item) {
        switch (item['key']) {
            //Ver recorrido de máquinas
            case 'see_performance_map':
                this.togglePerformanceMap(item['checked']);
                break;
            case 'see_performance_csv':
                this.togglePerformanceMapCSV(item['checked']);
                break;
            case 'see_humidity_map':
                this.toggleHumidityMap(item['checked']);
                break;
            case 'see_humidity_csv':
                this.toggleHumidityMapCSV(item['checked']);
                break;
            case 'machine_travel':
                this.toggleTravel(item['checked']);
                break;
            case 'see_ranch':
                this.toggleRanch(item['checked']);
                break;
            case 'see_avance':
                this.toggleAvance(item['checked']);
                break;
            case 'see_segments_of_work':
                this.toggleSegmentsOfWork(item['checked']);
                break;
            case 'see_calibration_passes':
                this.toggleCalibrationPasses(item['checked']);
                break;
            case 'see_most_representative':
                this.toggleMostRepresentativeImage(item['checked']);
                break;
        }
    }

    getVehicleData(vehicleId: number) {
        let data = '';
        let index = matchedIndexIdInArray(this.vehiclesOptions, vehicleId);
        if (index > -1) {
            let vehicle = this.vehiclesOptions[index];
            data = vehicle['vin'] + ' - ' + vehicle['description'];
        }
        return data;
    }

    toggleTravel(visible) {
        //Recorrido de máquinas
        let _this = this;
        if(!this.ranchHasMapData) return 
        if (visible) {
            this.toggleSegmentsOfWork(false);
            this.toggleCalibrationPasses(false);
            this.updateLayerOption('see_segments_of_work', 'checked', false);
            this.updateLayerOption('see_calibration_passes', 'checked', false);
            this.updateVehicleReferences(this.vehiclesOptions);
            this.mapHarvestDetail.showTravel(JSON.parse(JSON.stringify(this.geojsonTravel)), this.vehiclesOptions);
        } else {
            this.updateVehicleReferences(null);
            this.mapHarvestDetail.hideTravel();
        }
    }

    getReferenceColorByIndex(index) {
        return insuranceColors[index] ? insuranceColors[index] : getRandomColor();
    }

    toggleCalibrationPasses(visible) {
        //Clasificación por fecha/maquina de trabajo
        //new way of visualization based on linestrings
        if(!this.ranchHasMapData) return 

        if (visible) {
            this.toggleTravel(false);
            this.updateLayerOption('machine_travel', 'checked', false);
            this.mapHarvestDetail.saveAllCalibrations(this.geojsonCalibrationPasses);
            this.mapHarvestDetail.showCalibrationPasses(this.geojsonCalibrationPasses);
            this.updateCalibrationsReferences(this.referencesCalibrations);
            //  this.updateWorkLinesReferences(this.itemsSegments);
        } else {
            this.updateCalibrationsReferences(null);
            this.mapHarvestDetail.hideCalibrationsCheckbox();
            this.mapHarvestDetail.hideCalibrationPasses();
            //  this.updateWorkLinesReferences(null);
        }
    }
    toggleSegmentsOfWork(visible) {
        //Clasificación por fecha/maquina de trabajo
        //new way of visualization based on linestrings
        if(!this.ranchHasMapData) return 
        if (visible) {
            this.toggleTravel(false);
            this.updateLayerOption('machine_travel', 'checked', false);
            this.mapHarvestDetail.showSegmentsOfWork(this.geojsonSegmentsOfWork);
            this.updateWorkLinesReferences(this.itemsSegments);
        } else {
            this.mapHarvestDetail.hideSegmentsOfWork();
            this.updateWorkLinesReferences(null);
        }
    }

    toggleRanch(visible) {
        //Chacra
        if(!this.ranchHasMapData) return 
        if (visible) {
            // console.log("mostrar chacra");
            //checked change
            this.layersItems['see_ranch']['checked'] = true;
            this.mapHarvestDetail.toggleFeatureVisibility(this.basePolygons[0]);
        } else {
            this.layersItems['see_ranch']['checked'] = false
            this.mapHarvestDetail.toggleFeatureVisibility(this.basePolygons[0]);
            // console.log("ocultar chacra");
        }
    }

    toggleAvance(visible) {
        //Geocerca de Avance
        if(!this.ranchHasMapData) return 
        if (visible) {
            this.mapHarvestDetail.addExtraGeojsonLayer(this.harvestedPolygons);
        } else {
            this.mapHarvestDetail.removeExtraGeojsonLayer(this.harvestedPolygons);
        }
    }

    updateLayerOption(kei, prop, value) {
        this.layersItems[kei][prop] = value;
    }

    togglePerformanceMap(visible) {
        //Mapa Rinde
        if (visible) {
            this.unselectHumidityLayers();
            // this.updateLayerOption(1, 'checked', false);
            this.toggleHumidityMapCSV(false);
            // this.togglePerformanceMapCSV(false);
            let imgBounds = getParsedBounds(this.ranchBounds);
             this.showImageOnMap(this.performanceMapImage, imgBounds)
        } else {
             this.hideImageOnMap(this.performanceMapImage)
        }
    }

    toggleMostRepresentativeImage(visible) {
        if (visible) {
            this.updateLayerOption('see_most_representative', 'disabled', false);
            let url = this.mostRepresentativeImage['png_url'];
            let bounds = this.mostRepresentativeImage['bounds'];
            let imgBounds = getParsedBounds(bounds);
            this.showImageOnMap(url, imgBounds)
        } else {
            if (this.mostRepresentativeImage !== null) {
                this.hideImageOnMap(this.mostRepresentativeImage['png_url'])
            }
        }
    }

    togglePerformanceMapCSV(visible) {
        //Mapa Rinde
        if (visible) {
            this.unselectHumidityLayers();
            // this.togglePerformanceMap(false);
            // this.updateLayerOption(0, 'checked', false);
            let imgBounds = getParsedBounds(this.ranchBounds);
            this.showImageOnMap(this.performanceMapImageCSV, imgBounds)
        } else {
            this.hideImageOnMap(this.performanceMapImageCSV)
        }
    }

    toggleHumidityMap(visible) {
        //Mapa Humedad Telemetría
        if (visible) {
            this.unselectPerformanceLayers();
            // this.updateLayerOption(3, 'checked', false);
            // this.toggleHumidityMapCSV(false);
            let imgBounds = getParsedBounds(this.ranchBounds);
            this.showImageOnMap(this.humidityMapImage, imgBounds)
        } else {
            this.hideImageOnMap(this.humidityMapImage)
        }
    }

    showImageOnMap(image, imgBounds){
        if(this.ranchHasMapData){
            this.mapHarvestDetail.setGroundOverlayInMap(image, imgBounds, true)
        }
    }
    hideImageOnMap(image){
        if(this.ranchHasMapData){
            this.mapHarvestDetail.hideGroundOverlayFromMap(image)
        }
    }

    toggleHumidityMapCSV(visible) {
        //Mapa Humedad
        if (visible) {
            this.unselectPerformanceLayers();
            // // this.updateLayerOption(2, 'checked', false);
            // this.toggleHumidityMap(false);
            let imgBounds = getParsedBounds(this.ranchBounds);
            this.showImageOnMap(this.humidityMapCSVImage, imgBounds)
        } else {
            this.hideImageOnMap(this.humidityMapCSVImage)
        }
    }

    unselectPerformanceLayers() {
        this.updateLayerOption('see_performance_map', 'checked', false);
        this.updateLayerOption('see_performance_csv', 'checked', false);
        this.togglePerformanceMap(false);
        this.togglePerformanceMapCSV(false);
    }

    unselectHumidityLayers() {
        this.updateLayerOption('see_humidity_map', 'checked', false);
        this.updateLayerOption('see_humidity_csv', 'checked', false);
        this.toggleHumidityMap(false);
        this.toggleHumidityMapCSV(false);
    }

    modifyManualArea() {
        this.modifyRanch([], '');
    }

    forceCalculateNow() {
        let harvestId = this.getHarvestId;
        if (harvestId !== -1) {
            this.forcingCalculate = true;
            InsuranceServices.harvestForceRecalculate(harvestId)
                .then(response => {
                    this.forcingCalculate = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'La cosecha se está recalculando';
                    }
                    this.$_showAddPointOfInterest(msg);
                    // self.successLoadingDialog(msg);
                })
                .catch(error => {
                    this.forcingCalculate = false;
                    this.$_showAddPointOfInterest('No se pudo recalcular la cosecha');
                    // self.showCatchLoadingDialog(error);
                });
        }
    }
    forceRecalculateHarvest() {
        let harvestId = this.getHarvestId;
        if (harvestId !== -1) {
            this.recalculatingHarvest = true;
            InsuranceServices.harvestRecalculate(harvestId)
                .then(response => {
                    this.recalculatingHarvest = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'Cosecha recalculada con éxito';
                    }
                    this.$_showAddPointOfInterest(msg);
                    // self.successLoadingDialog(msg);
                })
                .catch(error => {
                    this.recalculatingHarvest = false;
                    this.$_showAddPointOfInterest('No se pudo recalcular la cosecha');
                    // self.showCatchLoadingDialog(error);
                });
        }
    }

    updateCoordsInRanchPolygon(updatedRanch){
        let updatedPoly = JSON.parse(JSON.stringify(this.basePolygons));
        this.basePolygons = [];
        if(updatedRanch['polygon']){
            let newPoly = updatedRanch['polygon'];
            updatedRanch['polygon']['features'] = this.getFeatureWithCustomId(newPoly['features']);
            let updatedGeometry = updatedRanch['polygon']['features'][0]['geometry'];
            updatedPoly[0]['geometry'] = updatedGeometry;
             let updatedGeoJson = {
                type: 'FeatureCollection',
                features: updatedPoly
            }
            this.basePolygons = updatedPoly;
            this.mapHarvestDetail.addGeoJson(updatedGeoJson);
            this.polygonsChanged += 1
            this.pendingMap(false);
        }
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    get formIsValid() {
        this.setErrorForm('')
        if (this.ranchName === '') {
            this.setErrorForm('No ingresó el nombre de la chacra')
            return false;
        }
        if (this.policySelected == null) {
            this.setErrorForm('No seleccionó Poliza')
            return false;
        }

        return true;
    }
}
